import { ModelBase } from "@shoothill/core";
import { observable, action } from "mobx";

export class InductionListItemModel extends ModelBase<InductionListItemModel> {
    @observable
    public id: string | null = null;
    @observable
    public toolboxTalkId: string | null = null;
    @observable
    public inductionUserId: string | null = null;
    @observable
    public signatureURL: string = "";
    @observable
    public isDeleted: boolean = false;
    @observable
    public createdByUserId: string | null = "";
    @observable
    public createdDate: string | null = "";
    constructor() {
        super();
    }

    @action
    public handleDelete = (val: boolean) => {
        this.isDeleted = val;
    };

    fromDto(model: InductionListItemDTO): void {
        this.id = model.id;
        this.toolboxTalkId = model.toolboxTalkId;
        this.inductionUserId = model.inductionUserId;
        this.signatureURL = model.signatureURL;
        this.isDeleted = model.isDeleted;
        this.createdByUserId = model.createdByUserId;
        this.createdDate = model.createdDate;
    }

    public static fromDtos(dtos: InductionListItemDTO[]): InductionListItemModel[] {
        const types: InductionListItemModel[] = [];

        for (const dto of dtos) {
            const model = new InductionListItemModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    toDto(): InductionListItemDTO {
        return {
            id: this.id,
            toolboxTalkId: this.toolboxTalkId,
            inductionUserId: this.inductionUserId,
            signatureURL: this.signatureURL,
            isDeleted: this.isDeleted,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
        };
    }
}

export interface InductionListItemDTO {
    id: string | null;
    toolboxTalkId: string | null;
    inductionUserId: string | null;
    signatureURL: string;
    isDeleted: boolean;
    createdByUserId: string | null;
    createdDate: string | null;
}
